module.exports = __webpack_public_path__ + "static/media/tienda-naranja-viajes-logo-variant.f9bed68c.svg";